import React from 'react';
import styled from '@emotion/styled';

import { slugify } from '../helpers/helpers';

const Button = styled.button`
  background-color: ${props => props.theme.colors.dark};
  border-radius: 5px;
  color: ${props => props.theme.colors.light};
  display: inline;
  margin-left: 15px;
  padding: ${props => props.theme.size.xsmall} ${props => props.theme.size.large};
  text-transform: uppercase;
  font-size: ${props => props.theme.size.medium};
  transform: translateY(-3px);

  &:hover {
    cursor: pointer;
  }
`;

const Input = styled.input`
  background-color: transparent;
  border-top: 0;
  border-right: 0;
  border-bottom: 1px solid ${props => props.theme.colors.dark};
  border-left: 0;
  color: ${props => props.theme.colors.dark};
  font-size: ${props => props.theme.size.large};
  padding-bottom: ${props => props.theme.size.xsmall};

  &::placeholder {
    color: ${props => props.theme.colors.darkTransparent};
    text-transform: uppercase;
  }
`;

const Form = styled.form`
  display: flex;
  align-items: center;
  padding: 35px ${props => props.theme.size.large} ${props => props.theme.size.xlarge};
  position: relative;
  width: 100%;
  justify-content: ${props => props.align}
`;

class AddPlanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { title: '' };

    this.onChangeInput = this.onChangeInput.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
  }

  onChangeInput(event) {
    const title = event.target.value;
    this.setState({ title });
  }

  onSubmitForm(event) {
    event.preventDefault();
    const planner = {
      title: this.state.title,
      activities: [] ,
    };
    this.props.addPlanner(planner);
    event.target.reset();
    window.location.href = "/#/" + slugify(this.state.title);
  }

  render() {

    return (
      <Form onSubmit={this.onSubmitForm} align={this.props.align}>
        <Input
          type="text"
          id="name"
          onChange={this.onChangeInput}
          placeholder="Add Planner"
          pattern=".{3,}"
          title="3 characters minimum"
          required
        />
        <Button type="submit">Add</Button>
      </Form>
    );
  }
}

export default AddPlanner;
